var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"data-details__action"},_vm.$listeners),[_c('span',[_c('TheGeoMarkerIcon')],1),_c('span',[_vm._v("Find on Map")])])}
var staticRenderFns = []

export { render, staticRenderFns }